<!--
 * @Author: Gaho
 * @Date: 2024-04-19 10:39:42
 * @LastEditors: Gaho
 * @LastEditTime: 2024-12-30 10:33:05
 * @Description: 
-->
<template>
    <div class="round-body">
        <p class="info-item">
            <span class="info-label">
                {{$t('RoundID')}}:
            </span>
            <span class="info-value">
                {{ history.num }}
            </span>
        </p>
        <p class="info-item">
            <span class="info-label">
                {{$t('Date')}}:
            </span>
            <span class="info-value">
                <!-- 04/19/24, 01:14:54 PM -->
                {{ formatDate(history.date) }}
            </span>
        </p>
        <p class="info-item">
            <span class="info-label">
                {{ $t('Result') }}:
            </span>
            <span class="info-value" :style="{ 'color': colors[history.sector] }">
                x{{ history.multi }}
            </span>
        </p>
        <p class="info-item">
            <span class="info-label">
                {{ $t('hash') }}:
            </span>
            <span class="info-value">
                {{ history.hash }}
            </span>
        </p>
        <p class="info-item">
            <span class="info-label">
                {{ $t('RandomSeed') }}:
            </span>
            <span class="info-value">
                {{ history.randomSeed }}
            </span>
        </p>
    </div>
</template>
<script lang="ts" setup>
import moment from 'moment';
import { colors } from '@/components/Casino/History/GameContent/Circle.vue';
const props = defineProps({
    history: {
        type: Object,
        default: () => {}
    }
})


const oTheI18n = useI18n();
const localeLang = computed(() => {
    return oTheI18n.locale.value;
})
/**
 * 格式化投注时间
 * @param date 投注日期
 */
const formatDate = (date: string) => {
    if (date){
        let localDate = date.replace('T', ' ').replace('Z', '');
        localDate = localeLang.value === 'cn' ? moment(localDate).format('HH:mm:ss') : moment(localDate).format('hh:mm:ss A')
        return localDate;
    }
    
}
</script>
<style lang="scss" scoped>
.round-body {
    margin-bottom: 24px;
    .info-item {
        font-size: 14px;
        font-weight: 600;
        line-height: 18px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-bottom: 1rem;
        .info-label {
            color: #55657e;
            font-size: 14px;
            font-weight: 600;
            line-height: 18px;
            margin-right: 4px;
        }
    }
}
</style>